/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import SectionHeadingStyle from '../elementsPreview/sectionHeadingStyle';
import SelectBox from '../formComponents/selectBox';
import Input from '../formComponents/input';
import ColorPicker from '../common/colorPicker';
import ImageUploader from '../../services/upload/imageUploader';

/*Assets*/
import ImgPlaceholder from '../../assets/images/img-placeholder.svg';

class ListSelectionModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      type: null,
      listType: null,
      images: [],
      imageLoader: [],
      label: [],
      listStyle: {},
      error: ""
    }
  }

  componentDidMount() {
  }

  setList(i){
    let j=0
    let temp1 = [];
    let temp2 = [];
    let temp3 = [];
    let type = 0;
    while(j<i){
      temp1.push("");
      temp3.push("");
      temp2.push(false);
      j++;
    }
    if(i==4) type= 1;
    else if(i==6) type= 2;
    else if(i==2) type = 3;
    else if(i==3) type = 4;
    this.setState({images: temp1, imageLoader: temp2, listType: i, label: temp3, type: type});
  }

  removeImage(i){
    let temp = this.state.images;
    temp[i] = "";
    this.setState({images: temp});
  }

  setImage(i, url){
    console.log(url)
    let temp1 = this.state.images;
    temp1[i] = url;
    this.setState({images: temp1});
  }

  startLoading(i, val){
    let temp = this.state.imageLoader;
    temp[i] = val; 
    console.log(val)
    this.setState({imageLoader: temp});
  } 

  setLabel(i, val){
    let temp = this.state.label;
    temp[i] = val;
    this.setState({label: temp});
  }

  async submitData(){
    this.setState({error: ""});
    let temp1 = this.state.images;
    let temp2 = this.state.label;
    let tempArry ={};
    let data =[]
    let e = false;
    temp1.forEach((image, i)=>{
      if(!image.length || !temp2[i].value){
        e = true;
      }
      else{
        data.push({img: image, title: temp2[i].label, id: temp2[i].value});
      }
    });
    if(e){
      this.setState({error: "Fill in all the fields"})
    }
    else{
      tempArry = { 
        "content": data, 
        "type": this.state.type, 
        "style": this.state.listStyle,
      };
      await this.props.success(tempArry, this.props.list);
      $("#listModal").modal("hide");
    }

  }

  render() {

    const styles = [
      { value: 1, label: 'Style - 1' },
      { value: 2, label: 'Style - 2' },
      { value: 3, label: 'Style - 3' },
      { value: 4, label: 'Style - 4' },
      { value: 5, label: 'Style - 5' },
      { value: 6, label: 'Style - 6' },
      { value: 7, label: 'Style - 7' },
      { value: 8, label: 'Style - 8' },
      { value: 9, label: 'Style - 9' },
      { value: 10, label: 'Style - 10' },
      { value: 11, label: 'Style - 11' },
      { value: 12, label: 'Style - 12' },
      { value: 13, label: 'Style - 13' },
      { value: 14, label: 'Style - 14' },
      { value: 15, label: 'Style - 15' },
      { value: 16, label: 'Style - 16' },
      { value: 17, label: 'Style - 17' },
      { value: 18, label: 'Style - 18' },
      { value: 19, label: 'Style - 19' },
      { value: 20, label: 'Style - 20' },
      { value: 21, label: 'Style - 21' },
      { value: 22, label: 'Style - 22' },
      { value: 23, label: 'Style - 23' },
      { value: 24, label: 'Style - 24' },
      { value: 25, label: 'Style - 25' },
      { value: 26, label: 'Style - 26' },
      { value: 27, label: 'Style - 27' },
      { value: 28, label: 'Style - 28' },
      { value: 29, label: 'Style - 29' },
      { value: 30, label: 'Style - 30' },
      { value: 31, label: 'Style - 31' },
      { value: 32, label: 'Style - 32' },
      { value: 33, label: 'Style - 33' },
      { value: 34, label: 'Style - 34' },
      { value: 35, label: 'Style - 35' },
      { value: 36, label: 'Style - 36' },
      { value: 37, label: 'Style - 37' },
      { value: 38, label: 'Style - 38' },
      { value: 39, label: 'Style - 39' },
    ]

    const styles2 = [
      { value: 1, label: 'Style - 1' },
      { value: 2, label: 'Style - 2' },
    ]


    return (
      <div className="modal fade" id="listModal" tabIndex="-1" role="dialog" aria-labelledby="listModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content e-list-modal">
            <div className="modal-header">
              <h2 className="modal-title">Choose list type</h2>
            </div>
            <div className="modal-body mt-3">
              <div className="e-demo-list-style">
                <div className="row">
                  <div className="col-lg-3">
                    <div className={this.state.listType==2? "e-card-transition e-demo-two-list text-center e-demo-list-wrap e-active": "e-card-transition e-demo-two-list text-center e-demo-list-wrap"} onClick={()=>this.setList(2)}>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img src={ImgPlaceholder} alt="Demo slider image"/>
                      <p className="mb-0">Two items list</p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className={this.state.listType==3? "e-card-transition e-demo-three-list text-center e-demo-list-wrap e-active": "e-card-transition e-demo-three-list text-center e-demo-list-wrap"} onClick={()=>this.setList(3)}>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img src={ImgPlaceholder} alt="Demo slider image"/>
                      <p className="mb-0">Three items list</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className={this.state.listType==4?"e-card-transition e-demo-four-list text-center e-demo-list-wrap e-active" : "e-card-transition e-demo-four-list text-center e-demo-list-wrap"} onClick={()=>this.setList(4)}>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img src={ImgPlaceholder} alt="Demo slider image"/>
                      <p className="mb-0">Four items list</p>
                    </div>
                  </div>
                  <div className="col-lg-6 mt-3">
                    <div className={this.state.listType==6? "e-card-transition e-demo-six-list text-center e-demo-list-wrap e-active": "e-card-transition e-demo-six-list text-center e-demo-list-wrap"} onClick={()=>this.setList(6)}>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img className="mr-2" src={ImgPlaceholder} alt="Demo slider image"/>
                      <img src={ImgPlaceholder} alt="Demo slider image"/>
                      <p className="mb-0">Six items list</p>
                    </div>
                  </div>   
                </div>
              </div>

              <div className="mt-4">
                <h6>Choose the list style</h6>
              </div>
              <div className="row">
                <div className="e-filter-wrap col-lg-3">
                  <SelectBox defaultValue={this.state.filterDefault} options={styles} selectchange={(val)=> this.setState({listStyle: val})} placeholder="Select list style"/>
                </div>
                <div className="col-lg-6 text-left">
                  <a className="e-view-style-link" href="https://vendor.truekhoj.com/assets/images/listing-styles.png" target="_blank">View the styles</a>
                </div>
              </div>

              {
                this.state.listType ?
                  <div>
                    <div className="mt-4">
                      <h6>Upload content</h6>
                    </div>
                    <div className="row">
                      {
                        this.state.images.map((image, i)=>(
                          <div className="col-lg-3">
                            <div className="e-subcategory-content text-center">
                              {
                                this.state.imageLoader[i] ?
                                  <div className="e-upload-loader"></div>
                                :
                                  <div>
                                    {
                                      image.length ?
                                        <div className="e-img-upload-content e-img-edit">
                                          <span className="e-close" onClick={() => this.removeImage(i)}></span>
                                          <img src={image} alt="banner"/>
                                        </div>
                                      :
                                        <span className="e-upload-btn mb-3" onClick={()=>$(`#image-uploader-${i}`).trigger("click")}>Upload image</span>
                                    }
                                  </div>

                              }
                              <SelectBox options={this.props.options} selectchange={(val)=>this.setLabel(i, val)} placeholder="Product"/>
                            </div>

                            <ImageUploader id={`image-uploader-${i}`} accept={".jpg,.png,.pdf"} index={i} tempKey={`list-image-${i}`} uploadSucess={(tempUrl, tempData, index) => this.setImage(i, tempUrl)} uploadStatus={(val) => this.startLoading(i, val)}/>
                          </div>
                        ))
                      }
                    </div>

                  </div>
                :
                  null
              }
              
              

            </div>
            {
                  this.state.error.length ?
                    <div className="row pt-2 px-3">
                      <div className='col-lg-12'>
                        <p className="text-danger e-error">{this.state.error}</p>
                      </div>
                    </div>
                  :
                    null
            }
            <div className="modal-footer">
              <span className="e-s-link-txt mr-4" data-dismiss="modal">Cancel</span>
              {
                this.state.listType && this.state.listStyle.value?
                  <button className="e-s-btn" value="Submit" onClick={()=>this.submitData()}>Submit</button>
                :
                  <button className="e-s-btn e-inactive" value="Submit" >Submit</button>
              }
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ListSelectionModal;
